import { useEditorStore } from '../../stores/editorStore'

export default function StatusBar() {
  const cursor = useEditorStore((s) => s.cursor)
  const getWordCount = useEditorStore((s) => s.getWordCount)
  const getLineCount = useEditorStore((s) => s.getLineCount)
  const getCharCount = useEditorStore((s) => s.getCharCount)
  const isModified = useEditorStore((s) => s.isModified)

  return (
    <div className="flex items-center justify-between px-3 py-1 border-t border-editor-border bg-editor-toolbar text-xs text-editor-fg/60 shrink-0">
      <div className="flex items-center gap-4">
        <span>
          行 {cursor.line}, 列 {cursor.column}
        </span>
        <span>{getLineCount()} 行</span>
        <span>{getWordCount()} 词</span>
        <span>{getCharCount()} 字符</span>
      </div>
      <div className="flex items-center gap-4">
        {isModified && <span className="text-amber-500">未保存</span>}
        <span>UTF-8</span>
        <span>Markdown</span>
      </div>
    </div>
  )
}
